import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CRMType as ParameterCRMType } from '../parameters/CRMType';
import { type CRMAuthResponse as SchemaCRMAuthResponse } from '../schemas/CRMAuthResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Returns authorization key and callback URL for CRM integration
 * @tags Integrations
 * @summary Get CRM authorization key and callback URL
 */
export const GetCRMAuthContentType = '' as const;
export type GetCRMAuthRequest = void;
export type GetCRMAuthResponses = LinkCommonErrorResponses & {
    /**
     * @description CRM authorization data retrieved successfully
     */
    '200': {
        'application/json': SchemaCRMAuthResponse;
    };
};
export type GetCRMAuthResponseSuccess = GetCRMAuthResponses['200']['application/json'];
export type GetCRMAuthSearchParams = ParameterCRMType['query'];
export type GetCRMAuthPathParameters = undefined;
export const GetCRMAuthUrl = '/integrations/crm' as const;
export const GetCRMAuthMethod = 'GET' as const;
export const getGetCRMAuthUrl = (_params?: GetCRMAuthPathParameters) => GetCRMAuthUrl;
